import { render, staticRenderFns } from "./EnterParentPassword.vue?vue&type=template&id=72375b5a&scoped=true&"
import script from "./EnterParentPassword.vue?vue&type=script&lang=js&"
export * from "./EnterParentPassword.vue?vue&type=script&lang=js&"
import style0 from "./EnterParentPassword.vue?vue&type=style&index=0&id=72375b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72375b5a",
  null
  
)

export default component.exports